"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var cssAnchorName = 'date-in-oembed';
exports.cssAnchorName = cssAnchorName;
var lang = navigator.language;

var DateInOEmbed = function DateInOEmbed(_ref) {
  var datetime = _ref.datetime;
  var date = new Date(datetime * 1000);
  var dateOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  };
  var timeOptions = {
    hour12: true,
    hour: 'numeric',
    minute: '2-digit'
  };

  var dateTimeOptions = _objectSpread(_objectSpread({}, dateOptions), timeOptions);

  var formattedDate = date.toLocaleDateString(lang, dateTimeOptions);
  return (0, _preact.h)("span", null, formattedDate);
};

var _default = DateInOEmbed;
exports.default = _default;